import type { ParsedUrlQuery } from "querystring"

export const getQueryParamStringValue = (
  value: ParsedUrlQuery["string"],
): string => {
  return value ? (Array.isArray(value) ? value[0] : value) : ""
}
